import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'semantic-ui-react';

const SelectDropdown = options => {
  const SelectDropdownComponent = ({
    input,
    label,
    placeholder,
    type,
    meta,
    ...custom
  }) => {
    const { touched, error, warning } = meta;
    const hasError = touched && error !== undefined;

    return (
      <span>
        {React.createElement(Select, {
          search: true,
          options,
          ...input,
          error: hasError,
          placeholder,
          ...custom,
          className: 'min-height',
          onChange: (param, data) => input.onChange(data.value),
        })}
        <br />
        {touched
          && ((error && <span className='error-text'>{error}</span>)
            || (warning && <span className='warn-text'>{warning}</span>))}
      </span>
    );
  };

  SelectDropdownComponent.propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
      warning: PropTypes.string,
    }).isRequired,
  };

  return SelectDropdownComponent;
};

export default SelectDropdown;
